



















































import { Component, Ref, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class AlertModal extends Vue {
  @Prop() alerts!: any[]

  dialog = true

  colors = [
    '',
    'green',
    '#bab759',
    'amber',
    'red'
  ]

  icons = [
    '',
    'fa-check',
    'fa-bell',
    'fa-exclamation-circle',
    'fa-exclamation-triangle'
  ]

  get getLastDate () {
    return this.alerts ? this.alerts[0].actualizado : ''
  }

  getColor (nivel: number) {
    return this.colors[nivel] || 'default'
  }

  getIcon (nivel: number) {
    return this.icons[nivel] || 'question'
  }
}
